import $ from 'Vendor/jquery'
import Logger from 'Vendor/@openmind/litelog'

import Marker from '../../marker'
import {MarkerClusterer, Cluster, ClusterIcon} from 'Vendor/gmaps-marker-clusterer'



/* Overrides `addMarker` method for binding cluster to Marker */
let _addMarker = Cluster.prototype.addMarker;
Cluster.prototype.addMarker = function(marker) {
  let result = _addMarker.apply(this, arguments);

  // Bind `cluster` if marker is not shown in map
  marker._cluster = this; //marker.getMap() == null ? this : null;

  return result;
};

/* Sets the correct image size to background */
let _createCss_ = ClusterIcon.prototype.createCss;
ClusterIcon.prototype.createCss = function(pos) {
  let str = _createCss_.apply( this, arguments );
  let style = [str + ";"];
  style.push(
    "background-size: " +  this.width_ + "px " + this.height_ + "px;"
  );
  return style.join("");
};

/* Sets the css class to cluster element */
let _icon_onadd = ClusterIcon.prototype.onAdd;
ClusterIcon.prototype.onAdd = function() {
  let result = _icon_onadd.apply(this, arguments);
  $(this.div_).addClass("cluster-gmap");
  return result;
};


const Log = new Logger("StoreLocator/GoogleMarker");


class GoogleMarker extends Marker {

  constructor(position, data, map) {

    super( data );

    position = position instanceof google.maps.LatLng ? position : new google.maps.LatLng( position );

    this.marker = new google.maps.Marker({
      position: position,
      title: data['name']
    });

    this.map = map;

    return this;
  }


  /**
   * @Override
   */
  set map(map){
    this.__map__ = map;
    this.marker.setMap( map ? map.Map : null );
    return this;
  };

  /**
   * @Override
   */
  get map(){
    return this.__map__;
  };


  /**
   * @Override
   */
  get storeData() {
    return this.data;
  }

  /**
   * @Override
   */
  get coordinates() {
    let latlng = this.marker.getPosition();
    return { lat: latlng.lat(), lng: latlng.lng() };
  }


  /**
   * @Override
   */
  set image(img) {

    let icon = {
      url: img.Url,
      scaledSize: new google.maps.Size(img.Size.w, img.Size.h)
    };

    this.marker.setIcon( icon );
    return this;
  }


  /**
   * @Override
   */
  get image() {
    let icon = this.marker.getIcon();
    return {
      Url: icon.url,
      Size: {
        w: icon.scaledSize.width,
        h: icon.scaledSize.height
      }
    };
  }

  /**
   * @Override
   */
  set label(text) {
    this.marker.setLabel( text );
    return this;
  }


  /**
   * @Override
   */
  get label() {
    return this.marker.getLabel();
  }

  /**
   * @Override
   */
  set title(text) {
    this.marker.title = text;
    return this;
  }


  /**
   * @Override
   */
  get title() {
    return this.marker.title;
  }

  /**
   * @Override
   */
  highlight(highlight,icon) {
    this.marker.setZIndex( highlight ? 999 : undefined );
    if(icon){
      this.image = icon;
    }
    return this;
  }

  /**
   * @Override
   */
  hide() {
    this.marker.setVisible(false);
    if ( this.cluster ) {
      var i = this.cluster.markers_.indexOf( this.marker );
      if ( i > -1 ) {
        this.cluster.markers_.splice(i, 1);
        this.cluster.updateIcon();
      }
    }
    this.marker.setMap( null );
  }

  /**
   * @Override
   */
  show() {
    // we need to `remove marker from cluster` before re-adding it to cluster (in case of)
    this.hide();
    this.marker.setVisible(true);
    this.marker.setMap( this.map.Map );
    if ( this.cluster ) {
      this.cluster.addMarker( this.marker );
    }
  }

  /**
   * @Override
   */
  get cluster() {
    return this.marker._cluster;
  }

  /**
   * @Override
   */
  highlightCluster(hover) {
    let cluster = this.cluster;
    if ( cluster ) {
      let icon = cluster.clusterIcon_;
      if ( icon ) {
        if(hover){
          $(icon.div_).addClass(`cluster${icon.index_ - 1}-hov`);
        }else{
          $(icon.div_).removeClass(`cluster${icon.index_ - 1}-hov`);
        }
      } else {
        Log.warn("no icon found for marker");
      }
    } else {
      Log.info("This marker seems to be in map, not in cluster");
    }
  }


  /**
   * Not used yet
   * Shows information about marker pin
   */
  showTooltip(html) {
    this.Tooltip = new google.maps.InfoWindow({
      content: html
    });
    this.Tooltip.open(this.map.Map, this.marker);
    return new Promise( (resolve) => {
      google.maps.event.addListener(this.Tooltip, 'domready', () => {
        resolve(this.Tooltip)
      });
      google.maps.event.addListener(this.Tooltip,'closeclick', () => {
        this.Tooltip.onclose && this.Tooltip.onclose();
      });
    });
  }

  /**
   * Not used yet
   * Hides information about marker pin
   */
  removeTooltip() {
    if (this.Tooltip) {
      this.Tooltip.close();
      this.Tooltip.setMap( null );
      delete this.Tooltip;
    }
  }

  /**
   * @Override
   */
  on(ev, fn){
    google.maps.event.addListener(this.marker, ev, fn);
    return this;
  };

  /**
   * @Override
   */
  off(ev){
    google.maps.event.clearListeners(this.marker, ev);
    return this;
  };

  /**
   * @Override
   */
  trigger(ev) {
    google.maps.event.trigger(this.marker, ev);
    return this;
  };


  clone() {
    return new GoogleMarker( this.coordinates, this.data );
  };


}

export default GoogleMarker;

















